module.exports = __webpack_public_path__ + "static/img/5339_phase_function_Paper_PointsHejduk_Prediction.da26895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5339_phase_function_Paper_PointsHejduk_Prediction.png
// module id = E9/I
// module chunks = 0